
import {initWebComponent} from "@/helpers/web-component-helper";
import {createGeoJsonLayer, toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {loadLinkedDataByBreadCrumbKey} from "@/helpers/layer/info/layer-info-info-linked-data-helper";

export class LayerInfoInfoItemBreadCrumbComponent extends HTMLElement {
    constructor(){
        super();

        const name = this.getAttribute('data-name')
        const active = this.getAttribute('data-active')
        const key = this.getAttribute('data-key')
        const depth = this.getAttribute('data-depth')
        const index = this.getAttribute('data-index')

        const template = document.createElement('template');

        let innerHtml = ``

        if(active === "true") {
            innerHtml += `<li class="active breadcrumb-item"><h3>` + name + `</h3></li>`
        } else {
            innerHtml += `<li class="breadcrumb-item"><a href="javascript:void(0)" class="">` + name + `</a></li>`
        }

        template.innerHTML = innerHtml

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            toggleGeoJsonLayer(key, index, true)
            loadLinkedDataByBreadCrumbKey(index, key, depth)
        })
    }
}

